import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import './OrgCreationPage.scss';
import { Link } from 'react-router-dom';

const title = "Settings";

export default class OrgCreation extends Component {

  componentWillMount() {
    document.title = title;
  }

  render() {
    return (
      <div>
        <h1>{ title }</h1>
        <hr />
        <div className="org-container">
          <Card> 
            <CardContent>
              <h2 style={ {fontSize: '15px', marginBottom: '12px'} }>GTD Credentials</h2>
              <span style={ {fontSize: '14px'} }>Add and Manage GTD Credentials</span>
            </CardContent>
            <CardActions>
              <div className="org-container__actions">
                <Link to="/gtd-credentials">
                  Manage GTD Credentials
                </Link>
              </div>
            </CardActions>
          </Card>
        </div>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/orgCreation/OrgCreationPage.js